import FormFieldWrapper from "./FormFieldWrapper/FormFieldWrapper";
import { CustomToggleFormFieldProps } from "interfaces";
import { Toggle } from "@amzn/uxm-aws-ui-components-react/lib/src/polaris";

/**
 * A FormField that provides a toggle input
 *
 * @param {string} label - The form field label
 * @param {string} value - The current input value
 * @param {function} setValue - Function to update the current input value
 * @param {string} errorText - Error message to display
 * @param {string} warningText - Warning message to display
 * @param {string} description - Description text for the field
 * @param {React.ReactNode} info - Additional info to display
 * @param {string} placeholder - Placeholder text for the date input
 * @param {boolean} disabled - Whether the input is disabled
 * @param {string} [testId] - Test identifier for the component
 *
 * @returns {JSX.Element} A FormField component with a Toggle
 */
const CustomToggleFormField = ({
    label,
    value,
    setValue,
    errorText,
    warningText,
    description,
    info,
    disabled,
    testId,
    touchpoint,
}: CustomToggleFormFieldProps) => {
    return (
        <FormFieldWrapper
            testId={testId}
            label={label}
            errorText={errorText}
            warningText={warningText}
            description={description}
            info={info}
            input={
                <Toggle
                    disabled={disabled}
                    onChange={({ detail }) => setValue(detail.checked)}
                    checked={value}
                    touchpoint={touchpoint}
                />
            }
        />
    );
};

export default CustomToggleFormField;
